// Vendor Libs
import {cloneDeep, filter, get, isEmpty, set, uniq} from 'lodash';

// Config
import searchFormsInitialStates, {getSearchFormsInitialState} from '../bootstrap-data/search-forms-initial-states';

const actions = {
    SEARCH_FORM_REMOVE_FIELD: (state, {formName, fieldName}) =>
        set(
            cloneDeep(state),
            [formName, 'visibleFields'],
            filter(get(state, [formName, 'visibleFields'], []), val => val !== fieldName)
        ),

    SEARCH_FORM_ADD_FIELD: (state, {formName, fieldName}) =>
        set(cloneDeep(state), [formName, 'visibleFields'], [...get(state, [formName, 'visibleFields'], []), fieldName]),

    SEARCH_FORM_ADD_FIELDS: (state, {formName, fieldNames}) =>
        set(
            cloneDeep(state),
            [formName, 'visibleFields'],
            uniq([...get(state, [formName, 'visibleFields'], []), ...fieldNames])
        ),

    SEARCH_FORM_RESET_FIELDS: (state, {formName}) =>
        set(cloneDeep(state), formName, getSearchFormsInitialState(formName)),

    PREFERENCES_LOAD: (state, {stores}) => {
        const searchFormData = get(stores, 'searchForm');

        return !isEmpty(searchFormData) ? cloneDeep(searchFormData) : state;
    },

    PREFERENCES_RESET: state => cloneDeep(searchFormsInitialStates),
};

const reducer = (state = searchFormsInitialStates, action) =>
    actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
